// Settings configuration
export const settingsData = [
  {
    key: "schoolSetting",
    label: "School Settings",
    children: [
      {
        key: "school",
        label: "School",
        link: "/settings/schoolSetting/school",
        description: "Manage school profile and basic information",
      },
      {
        key: "general",
        label: "General Settings",
        link: "/settings/schoolSetting/general",
        description: "Manage general school settings",
      },
      {
        key: "requiredDocument",
        label: "Required Documents",
        link: "/settings/studentSetting/requiredDocument",
        description: "Manage student required document settings ",
      },
    ],
  },
  {
    key: "communicationSetting",
    label: "Communication Settings",
    children: [
      {
        key: "whatsapp",
        label: "WhatsApp Settings",
        link: "/settings/communicationSetting/whatsapp",
        description: "Manage WhatsApp communication settings",
      },
    ],
  },
];
